import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    TMSDownloadReportParams,
    GetDirectionsTMSParams,
    TMSGetDirectionsResponse,
    TMSDownloadReportResponse,
    GetDirectionResponse,
    SetLogistPayload,
    AddSubdirectionPayload,
    GetInventoryTMSParams,
    TMSGetInventoryResponse,
    TMSGetNavigationsResponse,
    TMSDownloadReportInventoryParams,
    TMSDownloadReportInventoryResponse,
    GetTripsTMSParams,
    TMSGetTripsResponse,
    TMSGetTripsStatusesResponse,
    TMSDownloadReportTripsParams,
    TMSDownloadReportTripsResponse,
    GetTripResponse,
    TMSGetCommentsResponse,
    TMSGetTransportTypesResponse,
    GetTtnsTMSParams,
    TMSGetTtnsResponse,
    TMSDownloadReportTtnsParams,
    TMSDownloadReportTtnsResponse,
    GetTtnResponse,
    AddTtnTMSPayload,
    GetTripCommentsResponse,
    CancelTripTMSPayload,
    GetTtnCommentsResponse,
    SetTtnCommentPayload,
    GetPreTripCommentsResponse,
    GetCostStandardsParams,
    GetCostStandardsResponse,
    GetCarCapacitiesParams,
    GetCarCapacitiesResponse,
    CostStandardsPayload,
    CostStandardsUpdatePayload,
    BidChangeStatusPayload,
    BidCheckCostResponse,
    CheckCostParams,
    GetTripRouteResponse,
    GetDirectionSlaResponse,
    CheckImportFileResponse,
    AddDirectionTMSPayload,
    TmsGetDirectionResponse,
    UpdateDirectionTMSPayload,
    ImportInternalDirectionsPayload,
    GetLogistDirectionsResponse,
    GetDelayInfoResponse,
    GetLogistDirectionsParams,
    CompleteTripPayload,
    GetLoadStandardsParams,
    GetLoadStandardsResponse,
    LoadStandardsPayload,
    LoadStandardsUpdatePayload,
    NewCostStandardsPayload,
    CalculateCostStandardsPayload,
    CalculateCostStandardsResponse,
    GetCostStandardResponse,
    GetTripsAnalyticsParams,
    GetTripsAnalyticsResponse,
    DeleteSubdirectionPayload,
    GetCompleteDayStatusResponse,
    CostStandardCheckImportFileResponse,
    CostStandardImportLtlPayload,
    EditTtnPayload,
    CalculateParams,
    TmsCalculateResponse,
    RescheduleTtnPayload,
} from '@/new-services/types/tms'

type ApiGetDirectionsResponse = Promise<AxiosResponse<TMSGetDirectionsResponse>>
type ApiGetInventoryResponse = Promise<AxiosResponse<TMSGetInventoryResponse>>
type ApiGetTripsResponse = Promise<AxiosResponse<TMSGetTripsResponse>>
type ApiGetTtnsResponse = Promise<AxiosResponse<TMSGetTtnsResponse>>
type ApiGetTripsStatusesResponse = Promise<AxiosResponse<TMSGetTripsStatusesResponse>>
type ApiGetCommentsResponse = Promise<AxiosResponse<TMSGetCommentsResponse>>
type ApiGetTransportTypesResponse = Promise<AxiosResponse<TMSGetTransportTypesResponse>>
type ApiGetNavigationsResponse = Promise<AxiosResponse<TMSGetNavigationsResponse>>
type ApiDownloadReportResponse = Promise<AxiosResponse<TMSDownloadReportResponse>>
type ApiDownloadReportInventoryResponse = Promise<AxiosResponse<TMSDownloadReportInventoryResponse>>
type ApiDownloadReportTripsResponse = Promise<AxiosResponse<TMSDownloadReportTripsResponse>>
type ApiDownloadReportTtnsResponse = Promise<AxiosResponse<TMSDownloadReportTtnsResponse>>
type ApiGetDirectionResponse = Promise<AxiosResponse<GetDirectionResponse>>
type ApiGetDirectionSlaResponse = Promise<AxiosResponse<GetDirectionSlaResponse>>
type ApiGetTripResponse = Promise<AxiosResponse<GetTripResponse>>
type ApiGetTripRouteResponse = Promise<AxiosResponse<GetTripRouteResponse>>
type ApiGetLogistDirectionsResponse = Promise<AxiosResponse<GetLogistDirectionsResponse>>
type ApiGetTripCommentsResponse = Promise<AxiosResponse<GetTripCommentsResponse>>
type ApiGetDelayInfoResponse = Promise<AxiosResponse<GetDelayInfoResponse>>
type ApiGetPreTripCommentsResponse = Promise<AxiosResponse<GetPreTripCommentsResponse>>
type ApiGetTtnCommentsResponse = Promise<AxiosResponse<GetTtnCommentsResponse>>
type ApiGetTtnResponse = Promise<AxiosResponse<GetTtnResponse>>
type ApiDeleteSubdirectionResponse = Promise<AxiosResponse<void>>
type ApiSetLogistResponse = Promise<AxiosResponse<void>>
type ApiAddSubdirectionResponse = Promise<AxiosResponse<void>>
type ApiAddTripTMSResponse = Promise<AxiosResponse<void>>
type ApiCreateBidTMSResponse = Promise<AxiosResponse<void>>
type ApiCheckImportFileTMSResponse = Promise<AxiosResponse<CheckImportFileResponse>>
type ApiLoadDefectActTMSResponse = Promise<AxiosResponse<void>>
type ApiCancelTripTMSResponse = Promise<AxiosResponse<void>>
type ApiSetTtnCommentResponse = Promise<AxiosResponse<void>>
type ApiEditTtnResponse = Promise<AxiosResponse<void>>
type ApiEditCostResponse = Promise<AxiosResponse<void>>
type ApiSendCommentResponse = Promise<AxiosResponse<void>>
type ApiGetCostStandardsResponse = Promise<AxiosResponse<GetCostStandardsResponse>>
type ApiGetCostStandardResponse = Promise<AxiosResponse<GetCostStandardResponse>>
type ApiGetLoadStandardsResponse = Promise<AxiosResponse<GetLoadStandardsResponse>>
type ApiGetCarCapacitiesResponse = Promise<AxiosResponse<GetCarCapacitiesResponse>>
type ApiBidCheckCostResponse = Promise<AxiosResponse<BidCheckCostResponse>>
type ApiAddDirectionResponse = Promise<AxiosResponse<void>>
type ApiCalculateCostStandardsResponse = Promise<AxiosResponse<CalculateCostStandardsResponse>>
type ApiGetDirectionTMSResponse = Promise<AxiosResponse<TmsGetDirectionResponse>>
type ApiCalculateResponse = Promise<AxiosResponse<TmsCalculateResponse>>
type ApiExportByCityResponse = Promise<AxiosResponse<Blob>>
type ApiUpdateDirectionTMSResponse = Promise<AxiosResponse<void>>
type ApiCompleteTripResponse = Promise<AxiosResponse<void>>
type ApiGetTripsAnalyticsResponse = Promise<AxiosResponse<GetTripsAnalyticsResponse>>
type ApiPrintTripResponse = Promise<AxiosResponse<Blob>>
type ApiExportTripsAnalyticsResponse = Promise<AxiosResponse<Blob>>
type ApiGetCompleteDayStatusResponse = Promise<AxiosResponse<GetCompleteDayStatusResponse>>
type ApiCostStandardCheckImportFileResponse = Promise<
    AxiosResponse<CostStandardCheckImportFileResponse>
>
type ApiCostStandardImportLtlResponse = Promise<AxiosResponse<void>>
type ApiExportTtnsInvoicesResponse = Promise<AxiosResponse<Blob>>
type ApiRescheduleTtnResponse = Promise<AxiosResponse<void>>

export function getDirections(params: GetDirectionsTMSParams): ApiGetDirectionsResponse {
    return http.get('/tms/api/directions', { params })
}

export function getInventory(params: GetInventoryTMSParams): ApiGetInventoryResponse {
    return http.get('/tms/api/inventory-invoices', { params })
}

export function getTrips(params: GetTripsTMSParams): ApiGetTripsResponse {
    return http.get('/tms/api/trips', { params })
}

export function getTtns(params: GetTtnsTMSParams): ApiGetTtnsResponse {
    return http.get('/tms/api/ttns', { params })
}

export function getStatuses(): ApiGetTripsStatusesResponse {
    return http.get('/tms/api/statuses')
}

export function getComments(): ApiGetCommentsResponse {
    return http.get('/tms/api/comments')
}

export function getTransportTypes(): ApiGetTransportTypesResponse {
    return http.get('/tms/api/transport-types')
}

export function getNavigations(): ApiGetNavigationsResponse {
    return http.get('/tms/api/navigations')
}

export function downloadReport(params: TMSDownloadReportParams): ApiDownloadReportResponse {
    return http.get(`/tms/api/directions/report`, { params, responseType: 'blob' })
}

export function downloadReportInventory(
    params: TMSDownloadReportInventoryParams
): ApiDownloadReportInventoryResponse {
    return http.get(`/tms/api/inventory-invoices/report`, { params, responseType: 'blob' })
}

export function downloadReportTrips(
    params: TMSDownloadReportTripsParams
): ApiDownloadReportTripsResponse {
    return http.get(`/tms/api/trips/export`, { params, responseType: 'blob' })
}

export function downloadReportTtns(
    params: TMSDownloadReportTtnsParams
): ApiDownloadReportTtnsResponse {
    return http.get(`/tms/api/ttns/export`, { params, responseType: 'blob' })
}

export function getDirection(id: number): ApiGetDirectionResponse {
    return http.get(`/tms/api/directions/${id}`)
}

export function getDirectionSlaLtl(
    fromCityId: number,
    toCityId: number
): ApiGetDirectionSlaResponse {
    const params = {
        fromCityId,
        toCityId,
    }
    return http.get('/location/api/slas', { params })
}

export function getDirectionSlaFtl(
    fromCityId: number,
    toCityId: number
): ApiGetDirectionSlaResponse {
    const params = {
        fromCityId,
        toCityId,
        isExtended: 0,
    }
    return http.get('/location/api/ftl/slas', { params })
}

export function getTrip(id: number): ApiGetTripResponse {
    return http.get(`/tms/api/trips/${id}`)
}

export function getTripRoute(id: number): ApiGetTripRouteResponse {
    return http.get(`/tms/api/trips/${id}/route`, { params: { id } })
}

export function getLogistDirections(
    id: number,
    params: GetLogistDirectionsParams
): ApiGetLogistDirectionsResponse {
    return http.get(`/tms/api/internal-directions/parent/${id}`, { params: { id, ...params } })
}

export function getTtn(id: number, showBySectors?: number): ApiGetTtnResponse {
    return http.get(`/tms/api/ttns/${id}`, { params: { showBySectors } })
}

export function setLogist(direction_id: number, payload: SetLogistPayload): ApiSetLogistResponse {
    return http.put(`/tms/api/directions/set-logist/${direction_id}`, payload)
}

export function addSubdirection(payload: AddSubdirectionPayload): ApiAddSubdirectionResponse {
    return http.post('/tms/api/internal-directions', payload)
}

export function deleteSubdirection(data: DeleteSubdirectionPayload): ApiDeleteSubdirectionResponse {
    return http.delete('/tms/api/internal-directions', { data })
}

export function addTripTMS(payload: AddTtnTMSPayload): ApiAddTripTMSResponse {
    return http.post('/tms/api/trips/train', payload)
}

export function createBidTMS(payload: FormData): ApiCreateBidTMSResponse {
    return http.postFormData('/tms/api/bid', payload)
}

export function checkImportFile(payload: FormData): ApiCheckImportFileTMSResponse {
    return http.postFormData('/tms/api/internal-directions/check-import-file', payload)
}

export function loadDefectAct(id: number, payload: FormData): ApiLoadDefectActTMSResponse {
    return http.postFormData(`/tms/api/ttns/${id}/defect-act`, payload)
}

export function cancelTrip(id: number, payload: CancelTripTMSPayload): ApiCancelTripTMSResponse {
    return http.post(`/tms/api/trips/${id}/cancel`, payload)
}

export function getTripComments(stateId?: number): ApiGetTripCommentsResponse {
    return http.get('/tms/api/comments/trip', { params: { stateId } })
}

export function getDelayInfo(id: number): ApiGetDelayInfoResponse {
    return http.get(`/tms/api/trips/${id}/delay-info`, { params: { id } })
}

export function getPreTripComments(): ApiGetPreTripCommentsResponse {
    return http.get('/tms/api/comments/pre-trip')
}

export function getTtnComments(): ApiGetTtnCommentsResponse {
    return http.get('/tms/api/comments/ttn')
}

export function setComment(id: number, payload: SetTtnCommentPayload): ApiSetTtnCommentResponse {
    return http.put(`/tms/api/ttns/${id}/set-comment`, payload)
}

export function editTtn(id: number, payload: EditTtnPayload): ApiEditTtnResponse {
    return http.put(`/tms/api/ttns/${id}`, payload)
}

export function editCost(id: number, cost: number): ApiEditCostResponse {
    return http.put(`/tms/api/trips/${id}/update-cost`, { cost })
}

export function sendComment(
    id: number,
    commentId: number,
    stateId?: number | null
): ApiSendCommentResponse {
    return http.post(`/tms/api/trips/${id}/comment`, { commentId, stateId })
}

export function editBidCost(id: number, cost: number, isNds: number): ApiEditCostResponse {
    return http.put(`/tms/api/bid/update-cost/${id}`, { cost, isNds })
}

export function getCostStandards(params: GetCostStandardsParams): ApiGetCostStandardsResponse {
    return http.get('/tms/api/cost-standard', { params })
}

export function getCostStandard(id: number): ApiGetCostStandardResponse {
    return http.get(`/tms/api/cost-standard/${id}`)
}

export function getLoadStandards(params: GetLoadStandardsParams): ApiGetLoadStandardsResponse {
    return http.get('/tms/api/load-standards', { params })
}

export function getCarCapacities(params: GetCarCapacitiesParams): ApiGetCarCapacitiesResponse {
    return http.get('/tms/api/car-capacity', { params })
}

export function createCostStandards(
    payload: CostStandardsPayload | NewCostStandardsPayload
): Promise<AxiosResponse<void>> {
    return http.post('/tms/api/cost-standard', payload)
}

export function createLoadStandard(payload: LoadStandardsPayload): Promise<AxiosResponse<void>> {
    return http.post('/tms/api/load-standards', payload)
}

export function importInternalDirections(
    payload: ImportInternalDirectionsPayload
): Promise<AxiosResponse<void>> {
    return http.post('/tms/api/internal-directions/import', payload)
}

export function updateCostStandards(
    payload: CostStandardsUpdatePayload
): Promise<AxiosResponse<void>> {
    return http.put('/tms/api/cost-standard/update', payload)
}

export function updateNewCostStandards(
    id: number,
    payload: NewCostStandardsPayload
): Promise<AxiosResponse<void>> {
    return http.put(`/tms/api/cost-standard/${id}`, payload)
}

export function updateLoadStandards(
    id: number,
    payload: LoadStandardsUpdatePayload
): Promise<AxiosResponse<void>> {
    return http.put(`/tms/api/load-standards/${id}`, payload)
}

export function checkCost(
    params: CheckCostParams
): Promise<AxiosResponse<ApiBidCheckCostResponse>> {
    return http.get('/tms/api/bid-check-cost', { params })
}

export function changeBidStatus(
    bidId: number,
    payload: BidChangeStatusPayload
): Promise<AxiosResponse<void>> {
    return http.put(`/tms/api/bid/change-status/${bidId}`, payload)
}

export function changeBidStatusFtl(
    bidId: number,
    payload: BidChangeStatusPayload
): Promise<AxiosResponse<void>> {
    return http.put(`/cabinet/api/bid/${bidId}/change-status`, payload)
}

export function addDirectionTMS(payload: AddDirectionTMSPayload): ApiAddDirectionResponse {
    return http.post('/tms/api/directions', payload)
}

export function calculateCostStandards(
    payload: CalculateCostStandardsPayload
): ApiCalculateCostStandardsResponse {
    return http.post('/tms/api/cost-standard/calculate', payload)
}

export function getDirectionTMS(id: number): ApiGetDirectionTMSResponse {
    return http.get(`/tms/api/directions/${id}`)
}

export function updateDirectionTMS(
    id: number,
    payload: UpdateDirectionTMSPayload
): ApiUpdateDirectionTMSResponse {
    return http.put(`/tms/api/directions/${id}`, payload)
}

export function importExcelCostStandard(payload: FormData): Promise<AxiosResponse<void>> {
    return http.postFormData('/tms/api/cost-standard/import', payload)
}

export function importExcelLoadStandard(payload: FormData): Promise<AxiosResponse<void>> {
    return http.postFormData('/tms/api/load-standards/import', payload)
}

export function completeTrip(id: number, payload: CompleteTripPayload): ApiCompleteTripResponse {
    return http.post(`/tms/api/trips/${id}/complete`, payload)
}

export function getTripsAnalytics(params: GetTripsAnalyticsParams): ApiGetTripsAnalyticsResponse {
    return http.get('/tms/api/trips/analytics', { params })
}

export function printTrip(tripId: number): ApiPrintTripResponse {
    return http.get(`/tms/api/trips/${tripId}/export`, { responseType: 'blob' })
}

export function exportTripsAnalytics(
    params: GetTripsAnalyticsParams
): ApiExportTripsAnalyticsResponse {
    return http.get('/tms/api/trips/analytics/export', { params, responseType: 'blob' })
}

export function calculate(params: CalculateParams): ApiCalculateResponse {
    return http.get('/tms/api/invoice-warehouse/calculate', { params })
}

export function exportByCity(cityName: string): ApiExportByCityResponse {
    return http.get('/tms/api/workplace/inventory-invoice/export-by-city', {
        params: { cityName },
        responseType: 'blob',
    })
}

export function getCompleteDayStatus(): ApiGetCompleteDayStatusResponse {
    return http.get('/tms/api/pre-trips/complete-day-status')
}

export function costStandardCheckImportFile(
    form_data: FormData
): ApiCostStandardCheckImportFileResponse {
    return http.postFormData('/tms/api/cost-standard/check-import-file', form_data)
}

export function costStandardImportLtl(
    payload: CostStandardImportLtlPayload
): ApiCostStandardImportLtlResponse {
    return http.post('/tms/api/cost-standard/import-ltl', payload)
}

export function exportTtnsInvoices(ttnId: number): ApiExportTtnsInvoicesResponse {
    return http.get(`/tms/api/ttns/${ttnId}/invoices/export`, { responseType: 'blob' })
}

export function rescheduleTtn(tripId: number, payload: RescheduleTtnPayload): ApiRescheduleTtnResponse {
    return http.post(`/tms/api/trips/${tripId}/reschedule`, payload)
}

export default {
    addDirectionTMS,
    getDirectionTMS,
    updateDirectionTMS,
    editCost,
    getDirections,
    getInventory,
    getTrips,
    getTtns,
    getStatuses,
    getComments,
    getTransportTypes,
    getNavigations,
    downloadReport,
    downloadReportInventory,
    downloadReportTrips,
    downloadReportTtns,
    getDirection,
    getTrip,
    getTtn,
    setLogist,
    addSubdirection,
    deleteSubdirection,
    addTripTMS,
    createBidTMS,
    cancelTrip,
    getPreTripComments,
    getTripComments,
    getDelayInfo,
    getTtnComments,
    setComment,
    getCostStandards,
    getCarCapacities,
    createCostStandards,
    updateCostStandards,
    changeBidStatus,
    loadDefectAct,
    editBidCost,
    checkCost,
    getTripRoute,
    getLogistDirections,
    getDirectionSlaLtl,
    getDirectionSlaFtl,
    checkImportFile,
    importInternalDirections,
    sendComment,
    importExcelCostStandard,
    changeBidStatusFtl,
    completeTrip,
    getLoadStandards,
    createLoadStandard,
    importExcelLoadStandard,
    updateLoadStandards,
    updateNewCostStandards,
    calculateCostStandards,
    getCostStandard,
    getTripsAnalytics,
    printTrip,
    exportTripsAnalytics,
    getCompleteDayStatus,
    costStandardCheckImportFile,
    costStandardImportLtl,
    editTtn,
    calculate,
    exportByCity,
    exportTtnsInvoices,
    rescheduleTtn,
}
